"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onInitialClientRender = exports.wrapRootElement = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactJss = require("react-jss");

var _jss = _interopRequireDefault(require("./.cache/jss.js"));

var wrapRootElement = function wrapRootElement(_ref, _ref2) {
  var element = _ref.element,
      pathname = _ref.pathname;
  var _ref2$theme = _ref2.theme,
      theme = _ref2$theme === void 0 ? {} : _ref2$theme;
  var registry = new _reactJss.SheetsRegistry();
  var props = (0, _jss["default"])(_reactJss.jss);
  return _react["default"].createElement(_reactJss.JssProvider, (0, _extends2["default"])({}, props, {
    registry: registry
  }), _react["default"].createElement(_reactJss.ThemeProvider, {
    theme: theme
  }, element));
}; // remove the JSS style tag generated on the server to avoid conflicts with the one added on the client


exports.wrapRootElement = wrapRootElement;

var onInitialClientRender = function onInitialClientRender() {
  var ssStyles = window.document.getElementById("server-side-jss");
  ssStyles && ssStyles.parentNode.removeChild(ssStyles);
};

exports.onInitialClientRender = onInitialClientRender;